import React from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';
import { Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';

import {
  I18nProvider,
  EntityMapperContext,
} from '@uncinc/react-drupal-core';

import { Container, KitchenSinkComponentMapperContext } from '@uncinc/uncinc-react-kitchen-sink';

import blocksMapper from '../../mappers/blocks';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import profileMapper from '../../mappers/profile';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';

import i18next from '../../config/i18next';
import Entity from '../Entity';
import FooterMenu from '../../implementations/Menu/FooterMenu';

import { Breadcrumbs, Cookie, CustomRoute } from '../../components';
import Header from '../Header';
import Search from '../Search';

import './style.scss';
import '../../styles/main.scss';
import { FAQ_BASE_PATH, IS_CLIENT, SEARCH_PATH, APP_OPTIONS } from '../../config/constants';
import FaqEntity from '../FaqEntity';
import { usePrevious } from '../../helpers/usePrevious';

const entityTypeMapper = {
  block: blocksMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  profile: profileMapper,
  taxonomy: taxonomyMapper,
  view: viewsMapper,
};

const kitchenSinkComponentMapper = {
  // @TODO: Uncomment the Button here.
  // Currently the button type 'text' doesn't work if we do.
  // Button,
};

const App = () => {
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const prevPath = usePrevious(path);

  const classes = classNames('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
  });

  return (
    <EntityMapperContext.Provider value={entityTypeMapper}>
      <I18nProvider locale={language} i18next={i18next}>
        <KitchenSinkComponentMapperContext.Provider value={kitchenSinkComponentMapper}>
          <div className={classes} language={language}>
            <Header />
            <main className="main">
              {!childEntity.get('is_front') && entityType !== null && (
                <Container className="mt-6 mb-6">
                  <Breadcrumbs />
                </Container>
              )}
              <Switch>
                {/* Add routes here */}
                <CustomRoute path={SEARCH_PATH} render={() => (<Search />)} />
                <Route
                  path={`/${FAQ_BASE_PATH}/:themeTaxonomyPath`}
                  render={() => <FaqEntity prevPath={prevPath} />}
                />
                <Route render={() => (<Entity prevPath={prevPath} />)} />
              </Switch>
            </main>
            <FooterMenu />
            {IS_CLIENT && <Cookie />}
            <div id="modal-root" />
          </div>
        </KitchenSinkComponentMapperContext.Provider>
      </I18nProvider>
    </EntityMapperContext.Provider>
  );
};

export default App;
